<script>
import { formtPriceBr } from '@core/utils/filter';
import { resolverColorById } from '@core/utils/utils';
import { isPerfilClienteAtivo, isPerfilRepresentanteAtivo } from '@/libs/perfilCliente';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import { ocultarEstoqueCertificacao, tipoPedidoSelecionadoParaEstoque } from '@/utils/estoqueVisibilidade';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { calcularImpostosPic } from '@/services/Operacoes/picImpostos';
import { imagemProduto } from '@/utils/imagemUrl';
import { precoVisualizacao, ehValorDeCusto } from '@/utils/precoVisualizacao';

export default {
  name: 'CardItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  filters: {
    formtPriceBr,
  },
  data() {
    return {
      // Última quantidade aceita pela trava de estoque (fallback do revert)
      lastValidQty: parseInt(this.item && this.item.pedido_item_quantidade) || 1,
      tableFields: [
        {
          key: 'item', label: '', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'pp', label: 'PP', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'p', label: 'P', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'm', label: 'M', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'g', label: 'G', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'gg', label: 'GG', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'xg', label: 'XG', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'xgg', label: 'XGG', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'unico', label: 'ÚNICO', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'outros', label: 'OUTROS', headerClass: 'text-center', thClass: 'text-center',
        },
      ],
    };
  },
  computed: {
    tipoPedidoVisual() {
      return this.item.categoria_tipo_pedido || tipoPedidoSelecionadoParaEstoque(this.$store);
    },
    valorDeCustoVisual() {
      return ehValorDeCusto(this.tipoPedidoVisual);
    },
    precoVisual() {
      return precoVisualizacao({ item: this.item, tipoPedido: this.tipoPedidoVisual });
    },
    subtotalVisual() {
      return this.precoVisual === null ? null : this.precoVisual * Number(this.item.pedido_item_quantidade);
    },
    imagemExibicao() {
      return imagemProduto(this.item);
    },
    nomeClienteAbreviado() {
      const clienteAtual = this.$store.getters['InfoPedido/GET_CLIENTE_DATA']?.cliente;
      // Prioriza o cliente atual, inclusive ao restaurar itens de um carrinho.
      if (clienteAtual) return clienteAtual.clientenomeabreviado || 'Não informado';
      return this.item.cliente || 'Não informado';
    },
    // Badge de categoria (Venda/Doação) — só na visão do perfil Cliente.
    // categoria_tipo_pedido é anexada ao item no ModalEmbalagens (detecção automática).
    categoriaBadge() {
      if (!isPerfilClienteAtivo()) return null;
      const MAP = {
        WS: { texto: 'Venda', variant: 'success' },
        WD: { texto: 'Doação', variant: 'warning' },
        WC: { texto: 'Certificação', variant: 'secondary' },
      };
      return MAP[this.item.categoria_tipo_pedido] || null;
    },
    calcularTotal() {
      const total = parseFloat(this.item.pedido_item_preco_unitario * this.item.pedido_item_quantidade).toFixed(2);
      this.item.valor_total = parseFloat(total);
      return total;
    },
    calcularTotalFinal() {
      const totalFinal = parseFloat(this.item.precoComImposto * this.item.pedido_item_quantidade).toFixed(2);
      this.item.valorTotalComImposto = parseFloat(totalFinal);
      return totalFinal;
    },
  },
  methods: {
    resolverColorById,
    itemPicKey(item) {
      return `${item.pic_id ?? item.picid ?? ''}:${item.item_id ?? item.itemId ?? ''}:`
        + `${item.cdn_cor ?? ''}:${item.cdn_tamanho ?? ''}:${item.cdn_embalag ?? item.cdn_embalagem ?? ''}`;
    },
    isSamePicProduct(a, b) {
      return String(a.pic_id ?? a.picid ?? '') === String(b.pic_id ?? b.picid ?? '')
        && String(a.item_id ?? a.itemId ?? '') === String(b.item_id ?? b.itemId ?? '');
    },
    normalizarPicConfig(item) {
      return {
        ...item,
        picitemprecobase: item.picitemprecobase
          ?? item.picitemvalorpic
          ?? item.pedido_item_preco_unitario_base,
        picitemfaixas: item.picitemfaixas ?? [],
      };
    },
    picFiscalContext() {
      return {
        cliente: this.$store.getters['InfoPedido/GET_CLIENTE_DATA'] || {},
        capa: this.$store.getters['InfoPedido/GET_DATA_CAPA_PEDIDO'] || {},
        endereco: this.$store.getters['InfoPedido/GET_ENDERECO_ENTREGA'] || {},
      };
    },
    async recalcularPrecoPic(quantidade) {
      const todosItens = this.$store.getters['PedidosStore/getItemPedido'] || [];
      const targetKey = this.itemPicKey(this.item);
      const grupo = todosItens.filter((item) => item.item_pic_promocao
        && this.isSamePicProduct(item, this.item));
      const itens = grupo.map((item) => ({
        ...this.normalizarPicConfig(item),
        picitemquantidade: this.itemPicKey(item) === targetKey
          ? quantidade : Number(item.pedido_item_quantidade),
        picitemchave: this.itemPicKey(item),
      }));
      const quantidadeTotal = itens.reduce((total, item) => total + Number(item.picitemquantidade || 0), 0);
      itens.forEach((item) => { item.picitemquantidadetotal = quantidadeTotal; });

      const { cliente, capa, endereco } = this.picFiscalContext();
      const resultados = await calcularImpostosPic(itens, cliente, capa, endereco);
      const updates = itens.map((item) => {
        const imposto = resultados.find((resultado) => resultado.picitemchave === item.picitemchave)
          || resultados.find((resultado) => resultado.itemid === (item.item_id ?? item.itemId));
        if (!imposto || !Number.isFinite(Number(imposto.precoUnitario))
          || !Number.isFinite(Number(imposto.precoComImposto))
          || !Number.isFinite(Number(imposto.precoTabelaErp))
          || Number(imposto.precoTabelaErp) <= 0
          || Number(imposto.precoUnitario) <= 0 || Number(imposto.precoComImposto) <= 0) {
          throw new Error(`Não foi possível recalcular os impostos do item ${item.item_id ?? item.itemId}.`);
        }
        const qtd = Number(item.picitemquantidade);
        return {
          ...item,
          pedido_item_quantidade: qtd,
          pedido_item_preco_unitario: Number(imposto.precoUnitario),
          picitemprecobase: item.picitemprecobase,
          picitemfaixas: item.picitemfaixas,
          picitemdesconto: imposto.desconto,
          picitemfaixa: imposto.faixa,
          picitemquantidadetotal: quantidadeTotal,
          precoComImposto: Number(imposto.precoComImposto),
          precoTabelaErp: imposto.precoTabelaErp,
          base_icms: imposto.baseIcms || 0,
          valor_icms: imposto.valorIcms || 0,
          natureza_operacao_id_imposto: imposto.naturezaoperacaoidimposto || 0,
        };
      });
      return updates;
    },
    async avisarFalhaPrecoPic(error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Preço da promoção não atualizado',
          text: error.message || 'Não foi possível recalcular os impostos. A quantidade anterior foi mantida.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    },
    preventInvalidInput(event) {
      if (event.key === '0' && event.target.value === '') {
        event.preventDefault();
      }
      if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
        event.preventDefault();
      }
    },
    // Estoque TOTVS disponível para o item (null = sem informação → não bloqueia).
    async consultarEstoqueDisponivel() {
      try {
        // Cliente pode pedir qualquer quantidade (backorder): sem trava.
        if (isPerfilClienteAtivo()) return null;
        const id = this.item.item_id || this.item.itemId;
        if (!id) return null;
        const mapa = await new SLSEstoqueService().consultarEstoque([id]);
        const info = mapa && mapa[id];
        if (info && info.quantidade !== null && info.quantidade !== undefined) {
          return Number(info.quantidade);
        }
        return null;
      } catch (e) {
        return null;
      }
    },
    avisarEstoqueInsuficiente(disponivel) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Estoque insuficiente',
          text: isPerfilClienteAtivo() || ocultarEstoqueCertificacao(tipoPedidoSelecionadoParaEstoque(this.$store)) || (isPerfilRepresentanteAtivo() && Number(disponivel) > 50)
            ? 'Quantidade ajustada para o estoque disponível.'
            : `Quantidade ajustada para o estoque disponível (${disponivel}).`,
          icon: 'AlertTriangleIcon',
          variant: 'warning',
        },
      });
    },
    async handleQuantityInput(event) {
      let newQuantity = parseInt(event) || 1;

      if (newQuantity < 1 || isNaN(newQuantity) || newQuantity === 0) {
        newQuantity = 1;
      }

      if (this.item.regra_pic === 'CS' && newQuantity > this.item.saldo) {
        newQuantity = this.item.saldo;
      }

      // Trava de estoque: mesma regra usada ao adicionar o item — a quantidade
      // no carrinho não pode ultrapassar o estoque disponível no TOTVS.
      // Guarda contra respostas fora de ordem (digitação rápida).
      this._estoqueSeq = (this._estoqueSeq || 0) + 1;
      const seq = this._estoqueSeq;
      const disponivel = await this.consultarEstoqueDisponivel();
      if (seq !== this._estoqueSeq) return;
      if (disponivel !== null && newQuantity > disponivel) {
        this.avisarEstoqueInsuficiente(disponivel);
        const itemMultiplo = parseInt(this.item.itemMultiplo || 1);
        const ajustada = itemMultiplo > 1
          ? Math.floor(disponivel / itemMultiplo) * itemMultiplo
          : disponivel;
        // Sem estoque nem para 1 unidade: bloqueia o aumento, mantendo a
        // última quantidade válida conhecida.
        newQuantity = ajustada >= 1 ? ajustada : (this.lastValidQty || 1);
      }
      const previousQuantity = this.lastValidQty || Number(this.item.pedido_item_quantidade) || 1;
      if (this.item.item_pic_promocao) {
        this._picPriceSeq = (this._picPriceSeq || 0) + 1;
        const seq = this._picPriceSeq;
        const contextoFiscal = JSON.stringify(this.picFiscalContext());
        const itensOriginais = this.$store.getters['PedidosStore/getItemPedido'];
        try {
          const updates = await this.recalcularPrecoPic(newQuantity);
          if (seq === this._picPriceSeq) {
            if (JSON.stringify(this.picFiscalContext()) !== contextoFiscal
              || this.$store.getters['PedidosStore/getItemPedido'] !== itensOriginais
              || !itensOriginais.includes(this.item)) {
              throw new Error('O contexto fiscal ou o carrinho mudou. Confira os itens e tente novamente.');
            }
            this.$store.commit('PedidosStore/UPDATE_PIC_ITEM_PRICES', updates);
            this.lastValidQty = newQuantity;
          }
        } catch (error) {
          if (seq === this._picPriceSeq) {
            this.item.pedido_item_quantidade = previousQuantity;
            await this.avisarFalhaPrecoPic(error);
          }
        }
        return;
      }

      this.item.pedido_item_quantidade = newQuantity;
      this.lastValidQty = newQuantity;
      this.$store.commit('PedidosStore/UPDATE_ITEM_QUANTITY', {
        item: this.item,
        quantity: newQuantity,
      });
    },

    async incrementQuantity() {
      const maxQuantity = this.item.regra_pic === 'CS' ? this.item.saldo : 99999999;
      if (this.item.pedido_item_quantidade < maxQuantity) {
        // Trava de estoque no "+": não deixa passar do disponível no TOTVS.
        const disponivel = await this.consultarEstoqueDisponivel();
        if (disponivel !== null && this.item.pedido_item_quantidade + 1 > disponivel) {
          this.avisarEstoqueInsuficiente(disponivel);
          return;
        }
        this.item.pedido_item_quantidade += 1;
        await this.handleQuantityInput(this.item.pedido_item_quantidade);
      }
    },

    decrementQuantity() {
      if (this.item.pedido_item_quantidade > 1) {
        this.item.pedido_item_quantidade -= 1;
        this.handleQuantityInput(this.item.pedido_item_quantidade);
      }
    },

    validateQuantity() {
      if (!this.item.pedido_item_quantidade || this.item.pedido_item_quantidade < 1) {
        this.item.pedido_item_quantidade = 1;
        this.handleQuantityInput(1);
      }
    },
  },
  watch: {
    'item.pedido_item_quantidade': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.item.item_pic_promocao) return;
          this.$store.commit('PedidosStore/UPDATE_ITEM_QUANTITY', {
            item: this.item,
            quantity: newVal,
          });
        }
      },
    },
  },
};
</script>

  <template>
    <!-- Keep the legacy commercial-total evaluation; visual totals never replace its state. -->
    <b-card class="mb-1" :data-total-comercial="calcularTotalFinal">
      <b-row class="m-0">
        <b-col cols="12" md="2" align-self="center" class="text-center">
          <b-img
              :src="imagemExibicao"
              fluid
              class="img-fluid"
              width="100px"
              height="100px"
          />
        </b-col>
        <b-col cols="12" md="5">
          <span class="item-title">{{ item.item_descricao }}</span>
          <div class="d-flex flex-column item-info-block">
            <span>
              <span class="text-color-item-cart label-strong">{{ valorDeCustoVisual ? 'Valor de custo:' : 'Preço:' }}</span>
              <span v-if="precoVisual !== null" class="item-price"> {{ precoVisual | formtPriceBr }}</span>
              <span v-else class="item-price">—</span>
            </span>
            <span class="text-color-item-cart">
              <strong>ISBN:</strong>
              <span> {{ item.item_id || 'Não informado' }}</span>
            </span>
            <span class="text-color-item-cart" v-if="item.des_cor">
              <strong>Cor:</strong>
              <span> {{ item.des_cor }}</span>
            </span>
            <span class="text-color-item-cart" v-if="item.des_tamanho">
              <strong>Tamanho:</strong>
              <span> {{ (item.des_tamanho || '').toUpperCase() }}</span>
            </span>
            <span class="text-color-item-cart">
              <strong>Cliente:</strong>
              <span> {{ nomeClienteAbreviado }}</span>
            </span>
            <span class="text-color-item-cart" v-if="categoriaBadge">
              <b-badge :variant="categoriaBadge.variant" class="mr-1">
                {{ categoriaBadge.texto }}
              </b-badge>
            </span>
            <span class="text-color-item-cart" v-if="item.item_pic_promocao">
              <b-badge variant="primary" class="mr-1">
                Promocional
              </b-badge>
            </span>
            <span class="text-color-item-cart" v-if="item.itemMultiplo">
              <b-badge variant="info" class="mr-1">
                Item múltiplo
              </b-badge>
            </span>
          </div>
        </b-col>
        <b-col
            cols="12"
            md="2"
            align-self="center"
        >
          <div v-if="item.regra_pic === 'QE'">
            <b-form-input
              v-model.number="item.pedido_item_quantidade"
              type="number"
              :min="item.saldo"
              :max="item.saldo"
              disabled
              class="text-center"
            />
          </div>
          <div v-else-if="item.regra_pic === 'CS'">
            <div class="quantity-control">
              <b-button size="sm" variant="outline-danger" class="btn-quantity"
                @click="decrementQuantity" :disabled="item.pedido_item_quantidade <= 1">
                <feather-icon icon="MinusIcon" size="14" />
              </b-button>
              <b-form-input
                v-model.number="item.pedido_item_quantidade"
                type="number"
                :min="1"
                :max="item.saldo"
                @input="handleQuantityInput"
                @blur="validateQuantity"
                @keydown="preventInvalidInput"
                class="text-center quantity-value"
              />
              <b-button size="sm" variant="outline-success" class="btn-quantity"
                @click="incrementQuantity" :disabled="item.pedido_item_quantidade >= item.saldo">
                <feather-icon icon="PlusIcon" size="14" />
              </b-button>
            </div>
          </div>
          <div v-else-if="item.itemMultiplo">
            <b-form-input
              v-model.number="item.pedido_item_quantidade"
              type="number"
              :min="item.saldo"
              :max="item.saldo"
              disabled
              class="text-center"
            />
          </div>
          <div v-else>
            <div class="quantity-control">
              <b-button size="sm" variant="outline-danger" class="btn-quantity"
                @click="decrementQuantity" :disabled="item.pedido_item_quantidade <= 1">
                <feather-icon icon="MinusIcon" size="14" />
              </b-button>
              <b-form-input
                v-model.number="item.pedido_item_quantidade"
                type="number"
                :min="1"
                :max="99999999"
                @input="handleQuantityInput"
                @blur="validateQuantity"
                @keydown="preventInvalidInput"
                class="text-center quantity-value"
              />
              <b-button size="sm" variant="outline-success" class="btn-quantity"
                @click="incrementQuantity">
                <feather-icon icon="PlusIcon" size="14" />
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col
            cols="12"
            md="3"
            align-self="center"
            class="text-center"
        >
        <h4 v-if="subtotalVisual !== null">{{ subtotalVisual | formtPriceBr }}</h4>
        <h4 v-else>—</h4>
        </b-col>
      </b-row>
      <div class="actions-item">
        <feather-icon
            :id="`iconRemoverCart-${item.cdn_cor}-${item.cdn_tamanho}`"
            icon="Trash2Icon"
            class="mr-50 text-danger cursor-pointer"
            size="20"
            @click="$store.commit('PedidosStore/REMOVE_PRODUCT_ITEM_PEDIDO', item)"
        />
          <b-tooltip
              :target="`iconRemoverCart-${item.cdn_cor}-${item.cdn_tamanho}`"
              title="Remover do carrinho"
              placement="top"
          />
      </div>
    </b-card>
  </template>

<style scoped lang="scss">
.b-card {
  background: var(--sf-card-bg) !important;
  color: var(--sf-card-text) !important;
  border-color: var(--sf-card-border) !important;
}

.item-title {
  color: var(--sf-surface-text-dark) !important;
  font-weight: 700;
  font-size: 16px;
}

.item-info-block {
  padding-top: 5px;
}

.label-strong {
  font-weight: 700;
}

.item-price {
  color: var(--sf-accent) !important;
  font-weight: 700;
}

.quantity-control {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  .btn-quantity {
    padding: 0.15rem 0.4rem;
    line-height: 1;
    min-width: 30px;
  }

  .quantity-value {
    min-width: 60px;
    text-align: center;
    font-weight: 600;
    margin: 0;
    background: var(--sf-form-bg) !important;
    border: 1px solid var(--sf-form-border) !important;
    color: var(--sf-form-text) !important;
    border-radius: 6px;
  }
}

.actions-item {
  position: absolute;
  right: 10px;
  top: 10px;
}

.text-center {
  text-align: center;
}

.form-group {
  margin-bottom: 0;
}

.form-control {
  width: 100%;
}

.table th, .table td {
  padding: 0 !important;
}

.text-color-item-cart {
  color: var(--sf-surface-muted) !important;
}
</style>
